/* eslint-disable @typescript-eslint/no-explicit-any */
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { PublishScheduleSchema } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const publishSchedules = (
  payload: PublishScheduleSchema[]
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}publishSchedules`, payload);
};

export const changeStartOrEndPoint = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}changeStartOrEndPoint`, payload);
};

export const unscheduleAllRemainingVisits = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}unscheduleAllRemainingVisits`, payload);
};

export const unscheduleVisit = (
  visitIds: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}unscheduleVisit`, visitIds);
};

export const unscheduleWorkOrderFromVisit = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}unscheduleWorkOrderFromVisit`, payload);
};

export const confirmWorkOrders = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}confirmWorkOrders`, payload);
};

export const setDayOff = (payload: any): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}setDayOff`, payload);
};
export const setDayOn = (payload: any): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}setDayOn`, payload);
};

export const reverseVisitOrder = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}reverseVisitOrder`, payload);
};

export const moveOrRemoveCrewFromSchedule = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}moveOrRemoveCrewFromSchedule`, payload);
};

export const scheduleAsSeparateVisit = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}ScheduleAsSeparateVisit`, payload);
};

export const changeOrAddCrewFromSchedule = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}changeOrAddCrewFromSchedule`, payload);
};

export const moveVisitOrWorkOrder = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}moveVisitOrWorkOrder`, payload);
};

export const rescheduleRemainingVisits = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}rescheduleRemainingVisits`, payload);
};

export const moveScheduleToDate = (
  payload: any
): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}moveScheduleToDate`, payload);
};
